<template>
  <div class="update-password-verification-container">
    <div class="verification-message-card">
      <h2>Password Reset Email Sent</h2>
      <p>
        We sent you an email to update your password.<br>
        Please follow the link in the email to reset your password.
      </p>
      <router-link 
        to="/login" 
        class="back-to-login-link"
      >
        Back to Login
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "UpdatePasswordVerification"
};
</script>

<style scoped>
.update-password-verification-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  background: #f9f9f9;
}

.verification-message-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  padding: 2.5rem 2rem;
  text-align: center;
  max-width: 400px;
}

.verification-message-card h2 {
  color: #1976d2;
  margin-bottom: 1rem;
}

.verification-message-card p {
  color: #333;
  font-size: 1.1rem;
  margin-bottom: 2rem;
}

.back-to-login-link {
  color: #1976d2;
  text-decoration: underline;
  font-size: 1rem;
  transition: color 0.2s;
}

.back-to-login-link:hover {
  color: #0d47a1;
}
</style>
